import { createFileRoute } from "@tanstack/react-router";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import LightGallery from "lightgallery/react";
import { MINIGOLF_GALLERY_IMAGES } from "virtual:gallery-images";
import { useOptimizedImageArrayProps } from "@/components/image";
import {
  ScaffoldSection,
  ScaffoldSectionContainer,
  ScaffoldSectionContent,
  ScaffoldSectionHeader,
  ScaffoldSectionTitle,
} from "@/components/www/sections/scaffold";
import { seo } from "@/lib/seo";

export const Route = createFileRoute("/_www/angebote/bowling/galerie")({
  component: RouteComponent,
  head: () =>
    seo({
      title: "Bowling Galerie – Alte Papierfabrik Wuppertal",
      description:
        "Bilder aus der Bowlingbahn der Alten Papierfabrik Wuppertal – 12 Hightech-Bahnen, LED-Wand und Gastronomie.",
      path: "/angebote/bowling/galerie",
      image: "/images/og/bowling.jpg",
      imageAlt: "Bowlingkugel, Pins und Bowlingschuhe auf einer Bowlingbahn",
    }),
});

function RouteComponent() {
  const optimizedImages = useOptimizedImageArrayProps(
    MINIGOLF_GALLERY_IMAGES,
    1920,
    1080
  );
  return (
    <ScaffoldSection className="py-20">
      <ScaffoldSectionContainer>
        <ScaffoldSectionHeader>
          <ScaffoldSectionTitle>Galerie</ScaffoldSectionTitle>
        </ScaffoldSectionHeader>
        <ScaffoldSectionContent>
          <LightGallery
            elementClassNames="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
            plugins={[lgThumbnail, lgZoom]}
            speed={500}
          >
            {optimizedImages.map((image) => (
              <img alt={image.src} key={image.src} src={image.src} />
            ))}
          </LightGallery>
        </ScaffoldSectionContent>
      </ScaffoldSectionContainer>
    </ScaffoldSection>
  );
}
